import React, { useEffect } from 'react'
import Navbar from '../../Components/Navbar'
import BlogSelector from './components/BlogSelector'
import { useBlogsHook } from './useBlogsHook'
import { useSelector } from 'react-redux';
import { useNavigationHook } from '../../Hooks/useNavigationHook';

export default function Blogs() {
    const { returnSelectedBlogPage } = useBlogsHook();
    const {
        accessToken,
        refreshToken,
        UID,
    } = useSelector((state: any) => state.auth.value);
    const {
        navigateTo
    } = useNavigationHook();

    const checkAuth = () => {
        if (accessToken === '' || refreshToken === '' || UID === '') {
            navigateTo('/');
        };
    };

    useEffect(() => {
        checkAuth();
    }, []);

    return (
        <div className='flex justify-center items-center flex-col'>
            <Navbar />
            <BlogSelector />
            {returnSelectedBlogPage()}
        </div>
    )
}
